export default __webpack_public_path__ + "roboto-v29-latin-regular.woff2";